import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  TopToolbar,
  ListButton,
  ShowButton,
  CreateButton,
  required,
} from "react-admin";

const TagEditActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
    <CreateButton basePath={basePath} />
  </TopToolbar>
);

const TagEdit = (props) => (
  <Edit actions={<TagEditActions />} {...props}>
    <SimpleForm>
      <TextInput disabled label="Id" source="id" />
      <TextInput source="title" validate={required()} />
    </SimpleForm>
  </Edit>
);

export default TagEdit;
